module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero-tablet.81a96664.webp";